import { CalendarEventResponseStatus } from './external-calendar-event-input';
import { ID } from './id';

// Not the raw status: an unknown one, and no invitation at all, must collapse to Responded.
export enum ExternalEventResponseState {
  Responded = 'responded',
  AwaitingResponse = 'awaiting-response',
  Tentative = 'tentative',
}

export type ExternalCalendarEvent = {
  id: ID;
  // absent on responses from an older backend; without the pair the event
  // cannot be resolved back to a calendar, so editing falls back to the url
  connectionId?: ID;
  calendarId?: ID;
  title: string;
  url?: string;
  // absent on an older backend, so false means "not known to repeat", never "is a one-off"
  isRecurring?: boolean;
  start: { dateTime: string; date?: null } | { date: string; dateTime?: null };
  end: { dateTime: string; date?: null } | { date: string; dateTime?: null };
  color?: string;
  // absent on responses from a backend deployed before the list carried it — only an explicit
  // `false` means someone else organises the event, so an unknown value never blocks anything
  isOrganizer?: boolean;
  // null = nothing to answer; absent = backend deployed before it shipped
  selfResponseStatus?: CalendarEventResponseStatus | null;
  // client-only: an optimistic create the provider has not acknowledged yet, so its `id`
  // is a local placeholder. Nothing may target it — no drag, no popup, no context menu.
  pending?: boolean;
};
